export interface AlternateFlow {
  enabled?: boolean;
  label?: string;
  link?: string;
  redirectback?: boolean;
}

export interface TripData {
  confirmationNo: string;
  firstName: string;
  lastName: string;
  returnAction: string;
  originalSource: string;
  interstitial: boolean;
}

export interface NextgenReshopHeader {
  headerIcon: string;
  headerlabel: string;
  id: string;
}
